import Vue from 'vue';
import Vuex from 'vuex';
import constants from './constants';
import config from 'config';
import { separateGeoJsonLayers } from './utils';
import _ from 'lodash';
const Color = require("color")

import $ from 'jquery';

import {
  Config, PortalUser, Group, Role, GenericUpdateCreate, HttpRequest, Tag,
  Organization, MEA, Permission, Indicator, ReportWizard, SignedOff,
  Reminder, DataSource, Page, Category
} from './api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sectionNumber: 0,
    placement: {
      4: 'report',
      3: 'name',
      2: 'data_sources',
      1: 'indicator',
      0: 'mea'
    },
    dataType: '',
    colors: [
    '#FFA100', '#FF6400', '#FFFD00', '#61F700', '#00CAE6',
    '#0D00EC', '#6E00EA', '#EF00A7', '#FF0000', '#C766FD',
    '#89643A', '#527A34', '#2F355E', '#592659',
      // '#009b3a96', '#00CC4Cab', '#00CC4C', '#00F059',
      // '#1336EEab', '#1336EEab', '#1336EEab',
      // '#1336EEab', '#1336EEab', '#1336EEab',
      // '#00F059ab', '#00F059ab', '#00F059ab',
      // '#00F059ab', '#00F059ab', '#00F059ab',
      // '#00F059ab', '#00F059ab', '#00F059ab',
      // '#00F059ab', '#04bafcab', '#04bafcab',
      // '#04bafcab', '#04bafcab', '#04bafcab',
      // '#04bafcab', '#04bafcab', '#04bafcab',
       '#0599d0','#04bafc','#a9e4f9', '#E4BA62', '#d64161', '#feb236', '#4040a1', '#bc5a45', '#f18973', '#ADEF69',
      '#16847D','#2D73D2', '#2EF03E', '#C894B6', '#6E55E9', '#4802C6', '#CA6465', '#2D72F3',
      '#8CDF04', '#431BAE', '#9E7FB4','#0F7080', '#FBD6ED',  '#702F1B', '#F06D74','#A1C492',
      '#EA50A6', '#844EF7', '#3D18EB','#E956BD', '#52F656',  '#E14370', '#1C2028','#734143',
      '#35F796',  '#881308', '#13E0B7','#732BED', '#110B94','#9452A3', '#F2C16C',  '#42EA48',
       '#ff7b25', '#E4BA62', '#d64161', '#feb236', '#4040a1', '#bc5a45', '#f18973', '#ADEF69',
      '#16847D','#2D73D2', '#2EF03E', '#C894B6', '#6E55E9', '#4802C6', '#CA6465', '#2D72F3',
      '#4A44C0', '#1B9C32', '#F7D4C9','#4F6233', '#8040C0','#D0AF0E', '#8291EC',  '#9F14F1',
      '#EA8FC1','#3128B3', '#842A92',  '#D07F82', '#2175B0','#76C163', '#474483', '#44805E',
      '#9076AB','#B712BE', '#302C18',  '#F5317F', '#FAF160', '#CABC41','#B4B87D', '#70A793',
      '#273C81','#9DFDE2', '#4A69EE','#C1ACE2', '#d5e1df', ' #e3eaa7', '#eca1a6', '#b9936c',
      '#dac292', ' #86af49', '#E5DB35','#4F5B34'
    ],
    borderColor: [
      '#00F059', '#04bafc', '#04bafc',
      '#04bafc', '#04bafc', '#04bafc',
      '#04bafc', '#04bafc', '#04bafc',
      '#04bafc', '#04bafc', '#04bafc',
    ],
    xlsData: {},
    shapeLayerKey: 'GRIDCODE',
    chartType: 'bar',
    showMap: true,
    indicatorDataSources: [],
    meaIndicators: [],
    layerContainer: [],
    hasGeoJsonLayers: false,
    selectedGeoJsonLayers: {
      "type": "FeatureCollection",
      "features": [
      ]
    },
    geoJsonObjects:[],
    geoJsonOptions: {
      style: function () {
        return {
          weight: 2,
          color: '#ECEFF1',
          opacity: 1,
          fillColor: '#ff0000',
          fillOpacity: 1
        }
      }
    },
    selectedYear: null,
    comparativeYear: null,
    reportObject: {'data_sources':[]},
    selectedReport: {},
    geoJson: null,
    geoJsonLayers: [],
    // organization localStorage
    organizations: [],
    selectedOrganization: {},

    // user localStorage
    users: [],
    user: {
    },
    userPermissions: [],
    userGroups: [],

    // reminder localStorage
    reminders: [],
    selectedReminder: {},

    selectedUser:{},
    authToken: localStorage.token,
    sortingOrder: "first_name",

    // indicator localStorage
    indicator: {},
    indicators:[],
    selectedIndicator: {},
    indicatorDetails: {},

    // cateogry localStorage
    categories: [],

    // group localStorage
    groups: [],
    selectedGroup: {},

    // tag localStorage
    tags: [],
    selectedTag: {},

    // role localStorage
    roles: [],
    selectedRole: {},

    // signedoff localStorage
    signedoffs: [],
    selectedSignedOff: {},

    // permisison localStorage
    permissions: [],
    selectedPermission: {},

    // errors localStorage
    errors: [],
    hasErrors: false,
    previousPath: null,

    // user localStorage
    reports: [],
    reportSections: [],
    users: [],
    selectedUser: {},
    dataSources:[],
    selectedDataSource: {},
    acceptedDataSourceTypes: [],
    sortingOrder: "first_name",
    customers: [],

    // Mea localStorage
    meas: [],
    mea: {},
    selectedMea: {},

    filteredList: [],
    viewLayouts: {},
    showAdvancedFilter: false,
    advancedSearchPayload: [],

    loading: false,
    reportFilter: false,

    // grouping localStorage
    group: false,
    groupBy: null,
    dateFields: [
      'license_expiry_date',
      'original_date_of_issue',
      'date_of_birth',
      'expiry_date',
      'start_date'
    ],
    dateFormat: 'MMM D, YYYY',
  },
  getters: {
    getDataType (state) {
      return state.dataType;
    },
    getComparativeYear (state) {
      return state.comparativeYear;
    },
    getSelectedYear (state) {
      return state.selectedYear;
    },
    getLabels (state) {
      let labels = [];
      if (state.dataType === 'shp'){
        for (var i = state.geoJsonLayers.length - 1; i >= 0; i--) {
          let key = Object.keys(state.geoJsonLayers[i])[0];
          labels.push(key);
        }
        labels.sort(
        function(a, b){
          if (String(a) < String(b))return -1;
          if (String(a) > String(b))return 1;
          return 0;
        });
      }else if (state.dataType === 'xlsx' || state.dataType === 'xls') {
        let key = Object.keys(state.xlsData)[0];
        if (state.xlsData[key] !== undefined) {
          let obj = state.xlsData[key].data;
          labels = Object.keys(obj);
        }
      }
      return labels;
    },
    getNewChartData (state) {
      let chartData = [];
      if(state.dataType === 'shp'){
        for (let i = 0; i < state.geoJsonLayers.length; i++) {
          let key = Object.keys(state.geoJsonLayers[i])[0];
          let area = 0;
          state.geoJsonLayers[i][key].features.forEach(function(feature){
            area += feature.properties.AREA;
          });
          // console.log({y:Number(area.toFixed(2)), name: key, color:state.colors[i]})
          chartData.push({y:Number(area.toFixed(2)), name: key});
        }
        chartData.sort(
          function(a, b){
              var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
              if (nameA < nameB) //sort string ascending
                  return -1;
              if (nameA > nameB)
                  return 1;
              return 0; //default return value (no sorting)
          }
        );
        for (let x = 0; x < chartData.length; x++){
          chartData[x].color = state.colors[x];
        }
      }else if (state.dataType == 'xlsx' || state.dataType == 'xlsx') {
        if (state.xlsData[state.selectedYear] !== undefined) {
          let obj = state.xlsData[state.selectedYear].data;
          for (var label in obj) {

            if (obj.hasOwnProperty(label)) {
              console.log({y:Number(obj[label]), name: label});
              chartData.push({y:Number(obj[label]), name: label});
            }
          }
          for (let x = 0; x < chartData.length; x++){
            chartData[x].color = state.colors[x];
          }
        }
      }
      chartData.sort(
        function(a, b){
          var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
          if (nameA < nameB){ 
            return -1;
          }
          if (nameA > nameB){
            return 1;
          }
          return 0;
        }
      )
      console.log(state.xlsData.data, "checking")
      return chartData;
    },
    getChartData (state) {
      let obj = {};
      let chartData = [];
      let _chartData = []
      if(state.dataType === 'shp'){
        for (var i = state.geoJsonLayers.length - 1; i >= 0; i--) {
          let key = Object.keys(state.geoJsonLayers[i])[0];
          let area = 0;
          state.geoJsonLayers[i][key].features.forEach(function(feature){
            area += feature.properties.AREA;
          });
          chartData.push({x:area.toFixed(2), y: key});
        }
      }
      chartData.sort(
        function(a, b){
          if (parseFloat(a.x) > parseFloat(b.x))return -1;
          if (parseFloat(a.x) < parseFloat(b.x))return 1;
          return 0;
      });
      for (var x = 0; x < chartData.length; x++){
        _chartData.push(parseFloat(chartData[x].x));
      }

      return _chartData;
    },
    getChartDataWithKey ( state ){
      let obj = {};
      let chartData = [];
      let _chartData = [];
      if(state.dataType === 'shp'){
        for (var i = state.geoJsonLayers.length - 1; i >= 0; i--) {
          let key = Object.keys(state.geoJsonLayers[i])[0];
          let area = 0;
          state.geoJsonLayers[i][key].features.forEach(function(feature){
            area += feature.properties.AREA;
          });
          chartData.push({value:area.toFixed(2), key: key});
        }
      }
      return chartData;
    },
    selectedUser (state) {
      return state.selectedUser;
    },
    hasPerm: (state, getters) => (permission) =>{
      if(!permission) return true;
      if (permission == 'auth') return getters.isAuthenticated;

      let permissions = state.userPermissions;
      return permissions && permissions.indexOf(permission) > -1;
    },
    //------------------ Organization Getters Methods ----------------------//
    getOrganizations: (state) => {
      return state.organizations;
    },
    getOrganizationById: (state) => (organization_id) => {
      return state.organizations.find(
          organization => organization.id == organization_id
        );
    },
    getSelectedOrganization: (state) => {
      return state.selectedOrganization
    },
    getSelectedOrganizationById: (state) =>  {
      return state.selectedOrganization.id
    },
    getSelectedOrganizationByName: (state) =>  {
      return state.selectedOrganization.name
    },
    getSelectedOrganizationByAddress: (state) =>  {
      return state.selectedOrganization.address
    },
    getSelectedOrganizationList: (state) =>  {
      let list = [];
      let show = false;
      let data = {'title': null, 'list': list };
      let contacts = state.selectedOrganization.contacts;

      if (contacts != null) {
          for(var i=0;i<contacts.length;i  ) {
            let contact = contacts[i];
            list.push({ 'title': contact.category, 'value': contact.value });
          }
          show = true;
          data = {'title': constants.contact_title, 'list': list }
      }
      return { 'show': show, 'data': data }
    },
    //------------------ Reminder Getters Methods ----------------------//
    getReminders: (state) => {
      return state.reminders
    },
    getReminderById: (state) => (reminder_id) => {
      return state.reminders.find(
          reminder => reminder.id == reminder_id
        );
    },
    getSelectedReminder: (state) => {
      return state.selectedReminder
    },
    getSelectedReminderById: (state) =>  {
      return state.selectedReminder.id
    },
    getSelectedReminderByLabel: (state) =>  {
      return state.selectedReminder.label
    },
    getSelectedReminderByDescription: (state) =>  {
      return state.selectedReminder.description
    },
    getSelectedReminderByDays_Before: (state) =>  {
      return state.selectedReminder.days_before
    },
    getSelectedReminderByDays_After: (state) =>  {
      return state.selectedReminder.days_after
    },
    getSelectedOrganizationByStatus: (state) =>  {
      return state.selectedReminder.status
    },
    getSelectedReminderList: (state) =>  {
      let show = false;
      let data = {'title': null, 'list': [] };
      let contacts = state.selectedReminder.contacts;

      if (contacts != null) {
          show = true;
          data = {'title': constants.contact_title, 'list': contacts }
      }
      return { 'show': show, 'data': data }
    },
    //--------------------------------------------------------------------------
    getGroups: (state) => {
      return state.groups
    },
    getGroupById: (state) => (group_id) => {
      return state.groups.find(
          group => group.id == group_id
        );
    },
    getSelectedGroup: (state) => {
      return state.selectedGroup
    },
    selectedMea: (state) => {
      return state.selectedMea;
    },
    getSelectedGroupById: (state) =>  {
      return state.selectedGroup.id
    },
    getSelectedGroupByName: (state) =>  {
      return state.selectedGroup.name
    },
    getSelectedGroupUserList: (state) =>  {
      let count = 0;
      let list = [];
      let show = false;
      let data = {'title': null, 'list': list};
      let users = state.selectedGroup.users;

      if (users != null) {
          count = users.length;

          for(var i=0;i<users.length;i  ) {
            let user = users[i];
            list.push({ 'title': `${user.first_name} ${user.last_name}`,
                        'value': user.email });
          }
          show = true;
          data = { 'title': `${constants.user_title} (${count})`, 'list': list }
      }
      return { 'show': show, 'data': data };
    },
    //-------------------------------------------------------------------------
    //-------------------------- Role Getters Methods -----------------------//
    getRoles: (state) => {
      return state.roles;
    },
    getSelectedRole: (state) => {
      return state.selectedRole;
    },
    getRoleById: (state) => (role_id) => {
      return state.roles.find(
          role => role.id == role_id
        );
    },
    //--------------------------------- end ------------------------------------
    //------------------------ Tag Getters Methods ---------------------------//
    getTags: (state) => {
      return state.tags
    },
    getTagById: (state) => (tag_id) => {
      return state.tags.find(
          tag => tag.id == tag_id
        );
    },

    getSelectedTag: (state) => {
      return state.selectedTag
    },

    getSelectedTagId: (state) =>  {
      return state.selectedTag.id
    },

    getSelectedTagName: (state) =>  {
      return state.selectedTag.name
    },

    //-------------------------------------------------------------------------
    //---------------------- Permission Getters Methods ----------------------//
    getPermissions: (state) => {
      return state.permissions
    },
    getPermissionById: (state) => (permission_id) => {
      return state.permissions.find(
          permission => permission.id == permission_id
        );
    },
    //--------------------------- permission end -------------------------------
    //-------------------------- Error Getters Methods -----------------------//
    getErrors: (state) => {
      let list = [];

      if (state.errors.length > 0) {
        for(var i=0; i<state.errors.length; i++)
        list.push(state.errors[i].message);
      }

      state.errors = [];
      state.hasErrors = false;
      return list;
    },

    hasErrors: (state) => {
      return state.hasErrors;
    },
    //---------------------------- error end -----------------------------------
    //----------------------------- Other Methods ----------------------------//
    isAuthenticated: (state) => {
      return state.authToken != config.appToken;
    },
    selectedDataSource: (state) => {
      return state.selectedDataSource;
    },
    getDataSource: (state) => (id) => {
      for (let dataSource of state.dataSources){
        if (dataSource.id == id){
          return dataSource;
        }
      }
      return null;
    },
    getAuthToken: (state) => {
      return state.authToken;
    },
    getUser: (state) => {
      return state.user;
    },
    getindicators: (state) => {
      return state.indicators;
    },
    getSelectedIndicator: (state) => {
      return state.selectedIndicator;
    },
    //------------------ Mea Getters Methods ----------------------//
    getindicators: (state) => {
      return state.indicators;
    },
    getSelectedIndicatorByName: (state) =>  {
      return state.selectedIndicator.name;
    },
    getSelectedIndicator: (state) => {
      return state.selectedIndicator;
    },
    getIndicatorById: (state) => (id) => {
      for (let indicator of state.indicators){
        if (indicator.id === id){
          return indicator;
        }
      }
      return null;
    },
    getMeas:(state) => {
      return state.meas;
    },
   // getMeasById :(state) => {
   //    return state.meas.find(
   //      mea => mea.id == mea_id
   //    );
   //  },
    getSelectedMea:(state) => {
      return state.selectedMea
    },
    getSelectedMeaByName:(state) => {
      return state.selectedMea.name
    },
    getSelectedMeaByAbbreviation:(state) => {
      return state.selectedMea.abbreviation
    },
    getSelectedMeaIndicators:(state) => {
      return state.selectedMea.indicators
    },


     //--------------------------------------------------------------------------
    getLayout: (state) => (layoutName) => {
      const layout = state.viewLayouts[layoutName];
      const empty = { heading: [], sections: [] };
      return layout || empty;
    },
    getDownloadableItems: (state) => (dataType) => {
      let chartOptions = ['area', 'bar', 'column', 'line', 'pie'];
      let downloadableItems =  {
        'shp': [
          {'title': 'Data Source', 'name':'dataSource'},
          {'title': 'Report', 'name': 'report'},
          {'title': 'Chart', 'name': 'chart', 'options': chartOptions},
          {'title': 'Map', 'name':'map'}
        ],
        'xlsx': [
          {'title': 'Data Source', 'name':'dataSource'},
          {'title': 'Chart', 'name':'chart', 'options': chartOptions}
        ],
        'xls': [
          {'title': 'Data Source', 'name':'dataSource'},
          {'title': 'Chart', 'name':'chart', 'options': chartOptions}
        ]
      };
      if (dataType === undefined){
        return [];
      } else return downloadableItems[dataType];
    },
  },
  mutations: {
    // setUser(state, { user }) {
    //   state.user = user;
    // },
    setUsers(state, { users }) {
      state.users = users;
    },
    //---------------------- Indicator Properties ---------------------------
    setIndicators(state, { indicators }) {
      state.indicators = indicators;
    },
    //------------------------- Indicator end ----------------------------------
    //--------------------------- MEA Properties -------------------------------
    setMeas(state,  meas){
      state.meas = meas;
    },
    selectedMea(state, selectedMea){
      state.selectedMea = selectedMea;
    },
    selectUser(state, selectedUser) {
      state.selectedUser = selectedUser;
    },
    //------------- Reminder mutation properties ---------------------------
    setReminders(state, reminders) {
      state.reminders = reminders;
    },
    setSelectedReminder(state, selectedReminder) {
      state.selectedReminder = selectedReminder;
    },
    //------------- Organization mutation properties ---------------------------
    setOrganizations(state, organizations) {
      state.organizations = organizations;
    },
    setSelectedOrganization(state, selectedOrganization) {
      state.selectedOrganization = selectedOrganization;
    },
    //------------------------------ end ---------------------------------------
    //---------------------- Tag mutation properties ---------------------------
    setTags(state, tags) {
      state.tags = tags;
    },

    setSelectedTag(state, selectedTag) {
      state.selectedTag = selectedTag;
    },
    //------------------------------ end ---------------------------------------
    //---------------------- SignedOff Properties ------------------------------
    setSignedOffs(state, { signedoffs }) {
      state.signedoffs = signedoffs;
    },
    setSelectedSignedOff(state, selectedSignedOff) {
      state.selectedSignedOff = selectedSignedOff;
    },
    //------------------------- SignedOff end ----------------------------------
    //--------------- Permission mutation properties ---------------------------
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
    setSelectedPermission(state, selectedPermission) {
      state.selectedPermission = selectedPermission;
    },
    //-------------------- group mutation properties ---------------------------
    setGroups(state, groups) {
      state.groups = groups;
    },
    setSelectedGroup(state, selectedGroup) {
      state.selectedGroup = selectedGroup;
    },
    //-------------------- role mutation properties ---------------------------
    setRoles(state, roles) {
      state.roles = roles;
    },
    setSelectedRole(state, selectedRole) {
      state.selectedRole = selectedRole;
    },
    setSelectedDataSource(state, selectedDataSource) {
      state.selectedDataSource = selectedDataSource;
    },
    //------------------------- Grouping Properties ----------------------------
    setGrouping(state, grouping) {
      state.grouping = grouping;
    },
    //------------------------- Error Properties ----------------------------
    setErrors(state, message) {
      state.hasErrors = true;
      state.errors.push(message);
    },

    resetErrors(state) {
      state.hasErrors = false;
      state.errors = [];
    },

    setHasErrors(state, flag) {
      state.hasErrors = flag;
    },
    //-------------------------- errors end ------------------------------------
    //------------------------ Page Content Properties -------------------------
    setPageContent(state, { contents }) {
      if (contents) {
        state.meas = contents.hasOwnProperty('meas')? contents.meas : [];
        state.indicators = contents.hasOwnProperty('indicators')? contents.indicators : [];
        state.categories = contents.hasOwnProperty('categories')? contents.categories : []
      }
    },
    //-------------------------- Page Content end ------------------------------
    //----------------------- Filter Toggle Properties -------------------------
    toggleAdvancedFilter(state){
      state.showAdvancedFilter = !state.showAdvancedFilter
    },
    toggleLoading(state){
      state.loading = !state.loading
    },
    filterList(state, listFiltered){
      state.filteredList = listFiltered;
    },
    clearFilterList(state) {
      state.filteredList = [];
    },
    setViewLayoutConfig(state, { name, data }) {
      Vue.set(state.viewLayouts, name, data);
    },
    setAuthToken(state, token) {
      state.authToken = token;
    },
    setUser(state, user) {
      state.user = user;
      state.userPermissions = user.user_permissions;
      state.userGroups = user.groups;
    },

    setMea(state, mea){
      state.selectedMea = mea;
    },

    updateModel (state, { data, componentToSave, id, action }) {
      state.loading = true;
      if (action === 'save') {
        GenericUpdateCreate.create(data, componentToSave);
      } else if (action === 'update') {
        GenericUpdateCreate.update(data, componentToSave, id);
      }
    },

    fetchDataSources (state, dataSources) {
      state.dataSources = dataSources;
    },

    getById (state, { data, stateToUpdate }) {
      state[stateToUpdate] = data;
    },
    //-------------------- report mutation properties ---------------------------
    setSelectedReport(state, selectedReport) {
      state.selectedReport = selectedReport;
    },
    setReports (state, reports) {
      state.reports = reports;
    },

    updateReportObject (state, { data }) {
      let key = data.key;
      let _data = data.info;
      console.info(key, _data);
      if (key === 'data_sources'){
        state.reportObject[key] = [{'id': _data}];
        return;
      } else{
        state.reportObject[key] = _data;
      }
    },
    removeFromReportObject (state, key) {
      delete state.reportObject[key];
    },
    setMeaIndicators (state, meaIndicators) {
      state.meaIndicators = meaIndicators;
    },
    setIndicatorDataSources (state, indicatorDataSources) {
      state.indicatorDataSources = indicatorDataSources;
    },
    addDataSourceToReport (state, id) {
      try{
        state.reportObject['data_sources'].forEach(function(value, index){
          if (value.id === id){
            let result = state.reportObject['data_sources'].filter(object => object.id !== id)
            state.reportObject['data_sources'] = result;
          };

        });
      } catch (error) {
        state.reportObject['data_sources'] = [];
      }
      state.reportObject['data_sources'].push({'id': id});
    },
    setGeoJson (state, GeoJson) {
      state.geoJson = GeoJson;
      let finalLayers = [];
      let geoJsonLayers = {};
      let _layers = separateGeoJsonLayers(GeoJson, {}, state.shapeLayerKey);
      // Resets the geoJsonLayers array so that we don't have duplications
      state.geoJsonLayers = [];
      for (var key in _layers) {
        if (_layers.hasOwnProperty(key)) {
          let obj = {};
          let geoJSONFormat = {
            "type": "FeatureCollection",
            "features": [
            ],
            "color": '#713093'
          };
          let parsedLayers = _layers[key];
          geoJSONFormat.features.push.apply(geoJSONFormat.features, parsedLayers);
          obj[key] = geoJSONFormat;
          state.geoJsonLayers.push(obj)
        }
      }
    },
    setActiveLayer (state, layerToActivate) {
      state.layerContainer = [layerToActivate];
    },
    removeLayer(state, layer){
      let layerKey = layer.key;
      state.map.data.forEach(function (feature) {
        let featKey = feature.getProperty(state.shapeLayerKey);
        if (featKey === layerKey) {
          state.map.data.remove(feature);
        }
      });
    },
    setGeoJsonObjects(state, geoJsonObjects){
      state.geoJsonObjects.push.apply(state.geoJsonObjects, geoJsonObjects);
    },
    setChart (state, chart) {
      state.chartType = chart;
    },

    setDataType (state, type) {
      state.dataType = type;
    },
    resetGeoJsonVars (state) {
        state.layerContainer = [];
        state.geoJsonObjects = [];
        state.geoJsonLayers = [];
        state.reportObject = {'data_sources':[]}
    },
    setIndicator(state, indicator) {
      state.indicator = indicator;
    },
    setXlsData (state, xlsData) {
      if (xlsData) {
        let _xlsData = xlsData[0];
        state.xlsData = _xlsData;
        console.log('setXlsData',_xlsData)
        let year = Object.keys(_xlsData)[0];
        state.selectedYear = year;
      }
    },
    setSelectedYear (state, year) {
      state.selectedYear = year;
    },
    setComparitive(state, comparative){
      state.reportObject['comparative'] = comparative;
    },
    setCategories(state, categories){
      state.categories = categories;
    },
    setComparitiveYear (state, option) {
      state.comparativeYear = option;
    }
  },
  actions: {
    setComparitiveYear ({commit}, option) {
      commit('setComparitiveYear', option);
    },
    setComparitive ({commit}, comparative) {
      commit('setComparitive', comparative)
    },
    setSelectedYear ({commit}, year) {
      commit('setSelectedYear', year)
    },
    async setXlsData ({commit}, xlsData) {
      // console.log('XLS DATA', xlsData)
      commit('setXlsData', xlsData)
    },
    setMea({commit}, mea) {
      commit('setMea', mea)
    },
    setIndicator({commit}, indicator){
      commit('setIndicator', indicator)
    },
    setMEA({commit}, mea){
      commit('setMea', mea);
    },
    resetGeoJsonVars ({ commit} ) {
      commit('resetGeoJsonVars')
    },
    setDataType ({ commit }, type) {
      commit('setDataType', type);
    },
    setDisplayType ({ state }, displayType) {
      if (displayType == 'map'){
        $('.chart-visibility').css('z-index', 1);

        $('.map-visibility').css('z-index', 3);
        state.showMap = true;
      }else{
        $('.map-visibility').css('z-index', 1);
        $('.chart-visibility').css('z-index', 3);
        state.chartType = displayType;
        state.showMap = false;
      }
    },
    setChart ({ commit }, chart) {
      commit('setChart', chart)
    },
    setGeoJsonObjects({ commit }, geoJsonObjects) {
      commit('setGeoJsonObjects', geoJsonObjects);
    },
    removeLayer({ commit }, layer) {
      commit('removeLayer', layer);
    },
    addLayer({ state }, layer){
      state.map.data.addGeoJson(layer);
      state.map.data.setStyle(function(feature) {
          let layerKey = layer.key;
          let featKey = feature.getProperty(state.shapeLayerKey);
          let color =  feature.getProperty('color');
          if (featKey === layerKey) {
            color = layer.color
            feature.setProperty('color', color);
          }
          return {
            fillColor: color,
            strokeWeight: 2,
            strokeColor: color
          };
      });
    },
    removeLayer({ commit }, layer) {
      commit('removeLayer', layer);
    },
    removeAllLayers({ state }){
      $(".color-holder").removeClass('fa fa-check');
      state.map.data.forEach(function (feature) {
        state.map.data.remove(feature);
      });
    },
    setActiveLayer ({ commit, dispatch }, layerToActivate) {
        dispatch('addLayer', layerToActivate);
    },
    setGeoJson({commit}, GeoJson) {
      commit('setGeoJson', GeoJson);
    },
    addDataSourceToReport({ commit }, id) {
      commit('addDataSourceToReport', id)
    },
    async fetchIndicatorDataSources ({ commit }, { id }) {
      let indicatorDataSources = await ReportWizard.fetchDataSourceByIndicatorId(id);
      commit('setIndicatorDataSources', indicatorDataSources)
    },
    async fetchMeaIndicators ({ commit }, { id }) {
      let meaIndicators = await ReportWizard.fetchIndicatorsByMeaId(id);
      commit('setMeaIndicators', meaIndicators);
    },
    removeFromReportObject({ commit }, key) {
      commit('removeFromReportObject', key);
    },
    updateReportObject ({ commit }, { data }) {
      commit('updateReportObject', { data });
    },
    logoutUser ({ state, dispatch }) {
      state.authToken = config.appToken;
      state.user = {}
      PortalUser.logOut();
      dispatch('initUser');
    },
    forgotPassword({ state }, email){
      return PortalUser.forgotPassword(email);
    },
    // --------------------- Reminder properties ---------------------------
    async fetchAllReminders( {commit }){
      const reminders = await Reminder.getAllReminders()
      commit('setReminders', reminders)
    },
    async fetchSelectedReminder({ commit }, { id } ) {
      const selectedReminder = await Reminder.getSelectedReminder(id);
      commit('setSelectedReminder', selectedReminder);
    },
    async fetchReminderStatuses() {
      const reminderStatuses = await Reminder.getStatuses();
      return reminderStatuses
    },
    async updateSelectedReminder({commit}, { reminder }){
      const response = await Reminder.updateSelectedReminder(reminder);
      return response;
    },
    // --------------------- Report properties ---------------------------
    async fetchReports ( { commit }, id) {
      let httpRequest = new HttpRequest();
      const reports = await httpRequest.sendRequest('get', `${config.baseAPIURL}/reports/`, null);
      commit('setReports', reports);
    },
    async deleteSelectedReport( {state}, {id}){
      const response = await ReportWizard.deleteSelectedReport(id)
      return response;
    },
    async downloadReport ({state, getters}, report) {
      let reportConfig = {
          dataSourceOnly: false,
          name: state.reportObject['name'],
          type: this.getDataType,
          dataset: []
      }
      if (report === 'report') {
        if (getters.getDataType === 'shp') {
          let file = null;
          let geoJson = null;
          let label = null;
          let filesToCompare;

          for (var i = state.geoJsonObjects.length - 1; i >= 0; i--) {
            file = state.geoJsonObjects[i];
            geoJson = file['geo_json'];
            let _geoJson =  _.cloneDeep(geoJson);
            label = file['label'].split('.')[0];
            let year = label.split('_')[1];
            if (year === state.selectedYear || year === state.comparativeYear) {
              let _layer = {}
              _layer[label] = {}
              _layer[label]['label'] = label
              _layer[label]['data'] = separateGeoJsonLayers(
                  _geoJson, {}, state.shapeLayerKey
              );
             _layer[label]['year'] = year
             reportConfig.dataset.push(_layer)
            }
          }
          let response = await ReportWizard.downloadReport(reportConfig);
          console.log(reportConfig);
        } else if(this.getDataType === 'xlsx' || this.getDataType === 'xls'){
          reportConfig.dataSourceOnly = true;
          let response = await ReportWizard.downloadReport(reportConfig);
        }
      } else if (report === 'dataSource') {
        reportConfig.dataSourceOnly = true;
        let response = await ReportWizard.downloadReport(reportConfig);
      }
    },
    // --------------------- organization properties ---------------------------
    async fetchAllOrganizations( {commit }){
      const organizations = await Organization.getAllOrganizations()
      commit('setOrganizations', organizations);
    },
    async fetchSelectedOrganization({ commit }, { id } ) {
      const selectedOrganization = await Organization.getSelectedOrganization(id);
      commit('setSelectedOrganization', selectedOrganization);
    },
    async getById ({ commit }, { model, id, stateToUpdate }) {
      let data = await HttpRequest.getById(model, id);
      commit('getById', { data, stateToUpdate });
    },

    async updateSelectedOrganization( {state}, { organization }){
      const response = await Organization.updateSelectedOrganization(organization)
      return response;
    },

    async createOrganization( {state}, { organization }){
      const response = await Organization.createNewOrganization(organization)
      return response;
    },

    async deleteSelectedOrganization( {state}, { organization }){
      const response = await Organization.deleteSelectedOrganization(organization)
      return response;
    },
    async fetchUsers( { commit }){
      let users = await PortalUser.getAll();
      commit('setUsers', { users });
      return users;
    },

    async fetchSelectedUser({ commit }, { id } ) {
      let user = await PortalUser.getById(id);
      commit('setSelectedUser', user);
      return user;
    },

    async updateUser( {state}, { id, user }){
      const response = await PortalUser.update(user.id, user)
      return response;
    },

    async deleteUser( {state}, { user }){
      const response = await PortalUser.delete(user)
      return response;
    },
    //------------------------------- user end --------------------------------
    // -------------------------- group properties -----------------------------
    async fetchAllGroups( { commit }){
      const groups = await Group.getAllGroups();
      commit('setGroups', groups);
    },

    async fetchSelectedGroup({ commit }, { id } ) {
      const selectedGroup = await Group.getSelectedGroup(id);
      commit('setSelectedGroup', selectedGroup);
    },

    async createGroup( {state}, { group }){
      const response = await Group.createNewGroup(group)
      return response;
    },

    async updateSelectedGroup( {state}, { id, group }){
      const response = await Group.updateSelectedGroup(id, group)
      return response;
    },

    async deleteSelectedGroup( {state}, { group }){
      const response = await Group.deleteSelectedGroup(group)
      return response;
    },
    //------------------------------- group end --------------------------------
    // -------------------------- role properties ------------------------------
    async fetchAllRoles( { commit }){
      const roles = await Role.getAllRoles()
      commit('setRoles', roles);
    },
    async fetchSelectedRole({ commit }, { id } ) {
      const selectedRole = await Role.getSelectedRole(id);
      commit('setSelectedRole', selectedRole);
    },
    async createRole( {state}, { role }){
      const response = await Role.createNewRole(role)
      return response;
    },

    async updateSelectedRole( {state}, { role }){
      const response = await Role.updateSelectedRole(role)
      return response;
    },

    async deleteSelectedRole( {state}, { role }){
      const response = await Role.deleteSelectedRole(role)
      return response;
    },
    //--------------------------- role end -------------------------------------
    // ------------------------ signedoff properties ---------------------------
    async fetchAllSignedOffs( { commit }){
      const signedoffs = await SignedOff.getAllSignedOffs()
      commit('setSignedOffs', signedoffs);

    },
    async fetchSelectedSignedOff({ commit }, { id } ) {
      const selectedSignedOff = await SignedOff.getSelectedPermission(id);
      commit('setSelectedSignedOff', selectedSignedOff);
    },
    //-------------------------- signedoff end ---------------------------------
    // -------------------------- tag properties -----------------------------
    async fetchAllTags( { commit }){
      const tags = await Tag.getAllTags();
      commit('setTags', tags);
    },

    async fetchSelectedTag({ commit }, { id } ) {
      const selectedTag = await Tag.getSelectedTag(id);
      commit('setSelectedTag', selectedTag);
    },

    async createTag( {state}, { tag }){
      const response = await Tag.createNewTag(tag)
      return response;
    },

    async updateSelectedTag( {state}, { id, tag}){
      const response = await Tag.updateSelectedTag(id, tag)
      return response;
    },

    async deleteSelectedTag( {state}, {tag}){
      const response = await Tag.deleteSelectedTag(tag)
      return response;
    },
    //------------------------------- tag end ----------------------------------
    // ------------------------ permission properties --------------------------
    async fetchAllPermissions( { commit }){
      const permissions = await Permission.getAllPermissions()
      commit('setPermissions', permissions)
    },
    async fetchSelectedPermission({ commit }, { id } ) {
      const selectedPermission = await Permission.getSelectedPermission(id);
      commit('setSelectedPermission', selectedPermission);
    },
    //-------------------------- permission end --------------------------------
    async fetchDataSources ({ commit }) {
      let dataSources = await HttpRequest.getAll('data-sources/');

      for (let dataSource of dataSources){
        let dataSourceTags = dataSource.tags;
        for (let index in dataSource.tags){
          let retreivedTag = await Tag.getSelectedTag(dataSource.tags[index]);
          dataSource.tags[index] = retreivedTag.name;
        }
      }
      commit('fetchDataSources', dataSources)
    },
    async fetchSelectedDataSources ({ commit }, { id }) {
      let dataSource = await HttpRequest.getById('data-sources', id);
      commit('setSelectedDataSource', dataSource)
    },

    async updateSelectedDataSource ({state}, {data_source}) {
      const response = await DataSource.updateSelectedDataSource(data_source);
      return responseƒ
    },

    async deleteSelectedDataSource ({state}, {data_source}){
      const response = await DataSource.deleteSelectedDataSource(data_source);
      return response;
    },

    updateModel ({ commit }, { data, componentToSave, id, action }) {
      commit('updateModel', { data, componentToSave, id, action });
    },

    setGrouping({ commit }, grouping){
      commit('setGrouping', grouping)
    },

    // async fetchUsers({ commit, getters }) {
    //   const users = await PortalUser.getAll(getters.getAuthToken);  // replace with the getter??
    //   commit('setUsers', { users });
    // },
    // async fetchUsers({ commit, getters }) {
    //   // console.log("Doing some stuf!!");
    //   const users = await PortalUser.getAll(getters.getAuthToken);  // replace with the getter??
    //   commit('setUsers', { users });
    // },

    // ------------------------ indicators properties --------------------------
    async fetchIndicators({ commit }) {
      const indicators = await Indicator.getAllIndicators();
      commit('setIndicators', { indicators });
    },

    async fetchSelectedIndicator({ state }, { id } ) {
      const selectedIndicator = await Indicator.getSelectedIndicator(id);
      state.selectedIndicator = selectedIndicator;
    },

    async fetchIndicatorCategories({ state }){
      let indicatorCategories = await Indicator.getIndicatorCategories();
      Vue.set(state.indicatorDetails, 'categories', indicatorCategories);
      return state.indicatorDetails['categories'];
    },

    async fetchIndicatorPriorities({ state }){
      let indicatorPriorities = await Indicator.getIndicatorPriorities();
      Vue.set(state.indicatorDetails, 'priorities', indicatorPriorities);
      return state.indicatorDetails['priorities']
    },

    async createIndicator( {state}, { indicator }){
      const response = await Indicator.createNewIndicator(indicator)
      return response;
    },

    async updateSelectedIndicator( {state}, {indicator}){
      const response = await Indicator.updateSelectedIndicator(indicator)
      return response;
    },

    async deleteSelectedIndicator( {state}, {indicator}){
      const response = await Indicator.deleteSelectedIndicator(indicator)
      return response;
    },
    //------------------------- category properties ---------------------------------
    async fetchCategories({commit}){
      const categories = await Category.getAllCategories();
      commit('setCategories', categories);
    },
    //------------------------- category end ---------------------------------
    //------------------------- indicators end ---------------------------------
    // -------------------------- mea properties -------------------------------
    async fetchMeas({ commit, getters }){
      const meas = await MEA.getAllMeas();
      commit('setMeas', meas);
    },

    async fetchSelectedMea({ commit }, { id } ) {
      // Need to hit the API endpoint to get the selected mea
      const selectedMea = await MEA.getSelectedMea(id);
      commit('selectedMea', selectedMea);
    },

    async updateSelectedMea({ commit }, { mea } ) {
      // Need to hit the API endpoint to get the selected mea
      const response = await MEA.updateSelectedMea(mea);
      return response;
    },

    async deleteSelectedMea({ commit }, { mea } ) {
      // Need to hit the API endpoint to get the selected mea
      const response = await MEA.deleteSelectedMea(mea);
      return response;
    },

    async createMea( {state}, { mea }){
      const response = await MEA.createNewMea(mea)
      return response;
    },
    //---------------------------- mea end ------------------------------------
    //---------------------- data-source properties ---------------------------

    async createDataSource({state}, {data_source}){
      let dataSource = DataSource.createDataSource(data_source);
      if (dataSource != null){
        state.dataSources.push(dataSource);
      }
      return dataSource;
    },

    async fetchSelectedDataSource({ commit }, {id}){
      for (let dataSource of state.dataSources){
        if (dataSource.id === id){
          return dataSource;
        }
      }

      let dataSource = DataSource.getDataSourceById(id);
      state.selectedDataSource = dataSource;
      return state.selectedDataSource;
    },

    async fetchDataSourceAcceptedTypes ({state}) {
      let response = await DataSource.getAcceptedDataTypes();
      state.acceptedDataSourceTypes = [];
      for (let item of response){
        state.acceptedDataSourceTypes.push(item);
      }
      return state.acceptedDataSourceTypes;
    },

    async setupSelectedReport({ commit, state }, { report } ) {
      state.reportObject['name'] = report['name'];
      let key = Number(Object.keys(report)[0]);
      let obj = report[key];
      let type = obj.type;
      commit('setDataType', type);
      let _data = obj.data;

      if (type === 'shp'){
        let geoJsonObjects = _.cloneDeep(_data);
        commit('setGeoJsonObjects', geoJsonObjects)
        let type = report[key]['type'];
        commit('setDataType', type);
        let data = _.cloneDeep(_data[0]);;
        let geoJson = null;
        if (data !== null){
          geoJson = data.geo_json;
        }
        commit('setGeoJson', geoJson);
      }else if(type === 'xlsx' || type === 'xls') {
        commit('setXlsData', _data);
      }
    },
    //---------------------- data-source end ----------------------------------
    // ------------------------ front page properties --------------------------
    async fetchPageContent({ commit }) {
      const contents = await Page.getAssociatedPageContent();
      commit('setPageContent', { contents });
    },

    //------------------------- fron page end ----------------------------------
    async setSelectedUser({ commit }, { id } ) {
      // Need to hit the API endpoint to get the selected customer
      const selectedUser = await PortalUser.getById(id);
      commit('selectUser', selectedUser);
    },
    async setSelectedIndicator({ commit }, { id } ) {
      // Need to hit the API endpoint to get the selected customer
      const selectedIndicator = await Indicator.getSelectedIndicator(id);
      // console.info("Customer", id)
      commit('selectedIndicator', selectedIndicator);
    },
    setAdvancedSearchPayload({ commit }, payload){
      commit('setAdvancedSearchPayload', payload);
    },
    toggleAdvancedFilter({ commit }){
      commit('toggleAdvancedFilter');
    },
    toggleLoading({ commit }){
      commit('toggleLoading');
    },
    updateFilteredList({ commit }, listFiltered){
      commit('filterList', listFiltered);
    },
    clearFilteredList({ commit }) {
      commit('clearFilterList');
    },
    async fetchLayoutForView({ commit }, { name }) {
      const viewLayout = await Config.getLayoutForView(name);
      commit('setViewLayoutConfig', { name: name, data: viewLayout });
    },
    async initUser({ commit, state }) {
      if (state.authToken != "") {
        if(state.user.id) return true;
        let user = await PortalUser.getUser();
        if(user){
          commit('setUser', user);
          return true;
        }
      }
      return false
    },
    async login({ commit }, { username, password}) {
      const response = await PortalUser.login(username, password);
      if(response){
        commit('setAuthToken', response.token);
        commit('setUser', response.user);
        return true
      }
      return false;
    },
    async setSelectedIndicator({ commit }, { id } ) {
      const selectedIndicator = await Indicator.getSelectedIndicator(id);
      commit('selectedIndicator', selectedIndicator);
    },

    // ----------------------------  Error properties --------------------------
    checkErrors({ commit }, { message }) {
      commit('setErrors', { message });
    },

    resetErrors({ commit }) {
      commit('resetErrors');
    },

    setHasErrors({ commit }, flag){
      commit('setHasErrors', flag);
    },
    //------------------------- error end ---------------------------------
  }
})




// WEBPACK FOOTER //
// ./src/store.js